export default __webpack_public_path__ + "static/media/031-pyramids.da9c2867.svg";